var _rect, _mask, _g, _path, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoofSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ngfdbagxfa",
    width: 21,
    height: 22,
    x: 10,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 9h20.367v22H10V9z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ngfdbagxfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M30.18 15.348c-2.201-1.025-6.568-3.058-8.734-4.061-.172-.08-.348-.132-.526-.177.005-.035.02-.066.02-.102v-1.24c0-.424-.344-.768-.767-.768-.423 0-.768.344-.768.768v1.24c0 .036.017.069.022.104-.178.046-.355.1-.524.178-2.153 1.006-6.504 3.034-8.715 4.058-.316.146-.21.62.139.62h9.078v5.582h-4.092c-.376 0-.683.307-.683.684v.803c0 .378.307.683.683.683h4.099c-.001.011-.007.019-.007.029v5.716h-.628c-.423 0-.767.344-.767.767 0 .425.344.768.767.768h2.79c.425 0 .769-.343.769-.768 0-.423-.344-.767-.768-.767h-.627v-5.716c0-.01-.006-.018-.006-.029H24.8c.378 0 .684-.305.684-.683v-.803c0-.377-.306-.684-.684-.684H20.94v-5.581h9.099c.349 0 .455-.473.14-.62z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M29.203 22.953c-.423 0-.766.343-.766.768v2.333h-2.954c-.423 0-.767.343-.767.768 0 .248.126.46.31.6v2.811c0 .424.344.767.766.767.425 0 .77-.343.77-.767v-2.644h1.875v2.644c0 .424.343.767.766.767.425 0 .768-.343.768-.767v-6.512c0-.425-.343-.768-.768-.768z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "uq0upfy0hb",
    width: 6,
    height: 9,
    x: 10,
    y: 22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.452 22.953h5.256V31h-5.256v-8.047z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#uq0upfy0hb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M14.94 26.054h-2.954v-2.333c0-.424-.343-.768-.766-.768-.425 0-.768.344-.768.768v6.512c0 .423.343.768.768.768.423 0 .766-.345.766-.768V27.59h1.877v2.643c0 .423.343.768.768.768.423 0 .767-.345.767-.768V27.42c.183-.14.31-.35.31-.6 0-.424-.344-.767-.768-.767z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofSmall);
export default __webpack_public_path__ + "static/media/roof_small.5fb1ef7117487eade37dbbda692b8ee1.svg";
export { ForwardRef as ReactComponent };